import Index from '@/views/own-agreements/index'
import Welcome from '@/views/own-agreements/welcome'
import clientCarrierForm from '@/views/own-agreements/carrier-form'
import clientCarriers from '@/views/own-agreements/client-carriers'

const model = 'Carrier'

export default [
  {
    path: '/own-agreements',
    name: 'ownAgreements',
    component: Welcome,
    meta: { requiresAuth: true, auth: { model, permission: 'read' } }
  },
  {
    path: '/own-agreements/carriers',
    name: 'agreementCarriers',
    component: Index,
    meta: { requiresAuth: true, auth: { model, permission: 'read' } }
  },
  {
    path: '/own-agreements/carriers/:id/new',
    name: 'clientCarrierForm',
    component: clientCarrierForm,
    meta: { requiresAuth: true, auth: { model, permission: 'create' } }
  },
  {
    path: '/own-agreements/carriers/index',
    name: 'clientCarriers',
    component: clientCarriers,
    meta: { requiresAuth: true, auth: { model, permission: 'read' } }
  }
]
